import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const UseCases = (props) => {
  const { t } = useTranslation();
  const useCasesRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const useCaseItems = document.querySelectorAll('.use-case-item');
      
      useCaseItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight * 0.85;
        
        if (isVisible) {
          item.classList.add('visible');
          
          // Add a delay for cascading animation effect
          setTimeout(() => {
            const image = item.querySelector('.use-case-image');
            const textElements = item.querySelectorAll('.use-case-title-wrapper, .use-case-description-wrapper');
            const glowEffects = item.querySelectorAll('.glow-effect, .blur-effect');
            
            if (image) image.classList.add('visible');
            if (textElements) {
              textElements.forEach(el => el.classList.add('visible'));
            }
            if (glowEffects) {
              glowEffects.forEach((effect, i) => {
                setTimeout(() => {
                  effect.classList.add('visible');
                }, i * 150); // Stagger the glow effects
              });
            }
          }, 100);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    // Trigger once on load
    setTimeout(handleScroll, 500);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div id="use-cases" className="text-center" ref={useCasesRef}>
      <div className="container">
        {/* <div className="section-title">
          <h2>{t('UseCases.title')}</h2>
          <p>{t('UseCases.paragraph')}</p>
        </div> */}
        
        {props.data ? 
          t('UseCases.items', { returnObjects: true }).map((useCase, index) => (
            <div className={`row use-case-item use-case-${index}`} key={index}>
              <div className="col-xs-12 use-case-text-col">
                <div className="use-case-text">
                  <div className="use-case-title-wrapper">
                    <h3>{useCase.title}</h3>
                  </div>
                  <div className="use-case-description-wrapper">
                    <p>{useCase.description}</p>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 use-case-image-col">
                <div className="use-case-image">
                  <div className="image-container">
                    {/* Blur effects with different colors for each use case */}
                    {index === 0 ? (
                      <>
                        <div className="blur-effect blur-effect-1" style={{backgroundColor: 'rgba(60, 188, 161, 0.4)'}}></div>
                        <div className="blur-effect blur-effect-2" style={{backgroundColor: 'rgba(217, 31, 70, 0.25)'}}></div>
                        <div className="blur-effect blur-effect-3" style={{backgroundColor: 'rgba(207, 41, 159, 0.3)'}}></div>
                        <div className="blur-effect blur-effect-4" style={{backgroundColor: 'rgba(217, 85, 31, 0.3)'}}></div>
                        <div className="blur-effect blur-effect-5" style={{backgroundColor: 'rgba(117, 131, 128, 0.25)'}}></div>
                      </>
                    ) : index === 1 ? (
                      <>
                        <div className="blur-effect blur-effect-1" style={{backgroundColor: 'rgba(235, 94, 46, 0.35)'}}></div>
                        <div className="blur-effect blur-effect-2" style={{backgroundColor: 'rgba(60, 188, 161, 0.35)'}}></div>
                        <div className="blur-effect blur-effect-3" style={{backgroundColor: 'rgba(217, 31, 70, 0.3)'}}></div>
                        <div className="blur-effect blur-effect-4" style={{backgroundColor: 'rgba(217, 85, 31, 0.25)'}}></div>
                        <div className="blur-effect blur-effect-5" style={{backgroundColor: 'rgba(207, 41, 159, 0.2)'}}></div>
                      </>
                    ) : (
                      <>
                        <div className="blur-effect blur-effect-1" style={{backgroundColor: 'rgba(207, 41, 159, 0.35)'}}></div>
                        <div className="blur-effect blur-effect-2" style={{backgroundColor: 'rgba(235, 94, 46, 0.35)'}}></div>
                        <div className="blur-effect blur-effect-3" style={{backgroundColor: 'rgba(217, 31, 70, 0.25)'}}></div>
                        <div className="blur-effect blur-effect-4" style={{backgroundColor: 'rgba(60, 188, 161, 0.3)'}}></div>
                        <div className="blur-effect blur-effect-5" style={{backgroundColor: 'rgba(117, 131, 128, 0.3)'}}></div>
                      </>
                    )}
                    <div className="glow-effect glow-effect-1"></div>
                    <div className="glow-effect glow-effect-2"></div>
                    <div className="glow-effect glow-effect-3"></div>
                    <div className="glow-effect glow-effect-4"></div>
                    <img 
                      src={useCase.image} 
                      className="img-responsive" 
                      alt={useCase.title}
                      draggable="false"
                      onContextMenu={(e) => e.preventDefault()}
                      style={{ WebkitTouchCallout: 'none', userSelect: 'none' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )) : "loading..."
        }
      </div>
    </div>
  );
}; 